/* eslint-disable no-undef */
AFRAME.registerComponent('disable-culling', {
  init: function() {
    var object3D = this.el.sceneEl.object3D;
    object3D.traverse(node => {
      node.frustumCulled = false;
    });
  },
});
